import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../../../components/CustomFormsComponents/CustomField';
import { useAppSelector } from '../../../../../hooks/reduxHooks';
import { ValidationName } from '../../../../../components/CustomFormsComponents/hooks/useValidation';
import { TEST_IDS } from '../testIds';
export const RESPONSIBLE_CHARGE_ID_VALUE = 1;

const useResponsibleFieldsConfig = ({ t, formData, handleBlurValidation }: any) => {
    const [responsibleFieldsConfig, setResponsibleFieldsConfig] = useState<FieldConfig[]>([]);

    const { cargos, tiposContratacion, representaciones } = useAppSelector(
        (state) => state.datosParametricos.data
    );
    
    useEffect(() => {
        const fieldsConfig: FieldConfig[] = [
            {
                type: 'text',
                label: t('responsiblesAndContractorsForms.newResponsible.inputs.name') as string,
                name: 'name',
                required: true,
                value: formData.fullname,
                disabled: false,
                helperText: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.name'
                ) as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 6 },
                testID: TEST_IDS.responsibles.newResponsibleFormFields.name,
                validations: [{ name: 'required' }, {name: "lettersOnly"}]
            },
            {
                type: 'text',
                label: t('responsiblesAndContractorsForms.newResponsible.inputs.surname') as string,
                name: 'surname',
                required: true,
                value: formData.fullname,
                disabled: false,
                helperText: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.surname'
                ) as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 6 },
                testID: TEST_IDS.responsibles.newResponsibleFormFields.surname,
                validations: [{ name: 'required' }, {name: "lettersOnly"}]
            },
            {
                type: 'text',
                label: t('responsiblesAndContractorsForms.newResponsible.inputs.cuit') as string,
                name: 'cuit',
                required: true,
                value: formData.cuit,
                disabled: false,
                helperText: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.cuit'
                ) as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                maxLength: 11,
                minLength: 11,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.responsibles.newResponsibleFormFields.cuit,
                validations: [{ name: 'required' }, { name: 'fixedLength', param: 11 }]
            },
            {
                type: 'autocomplete',
                label: t('responsiblesAndContractorsForms.newResponsible.inputs.charge') as string,
                name: 'charge',
                required: true,
                value: formData.charge,
                disabled: !cargos,
                options: cargos || [],
                helperText: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.charge'
                ) as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.responsibles.newResponsibleFormFields.charge,
                validations: [{ name: 'required' }]
            },
            {
                type: 'autocomplete',
                label: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.respresentation'
                ) as string,
                name: 'respresentation',
                required: true,
                value: formData.representation,
                options: representaciones || [],
                disabled: !representaciones,
                helperText: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.respresentation'
                ) as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.responsibles.newResponsibleFormFields.respresentation,
                validations: [{ name: 'required' }]
            },
            {
                type: 'autocomplete',
                label: t('responsiblesAndContractorsForms.newResponsible.inputs.status') as string,
                name: 'status',
                required: true,
                value: formData.status,
                disabled: !tiposContratacion,
                helperText: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.status'
                ) as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.responsibles.newResponsibleFormFields.status,
                options: tiposContratacion || [],
                validations: [{ name: 'required' }]
            },
            {
                type: 'text',
                label: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.habilitationTitle'
                ) as string,
                name: 'habilitationTitle',
                required: true,
                value: formData.habilitationTitle,
                disabled: false,
                helperText: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.habilitationTitle'
                ) as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.responsibles.newResponsibleFormFields.habilitationTitle,
                validations: [{ name: 'required' }, {name: 'lettersOnly'}]
            },
            {
                type: 'text',
                label: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.licenceNumber'
                ) as string,
                name: 'licenceNumber',
                required: true,
                value: formData.licenceNumber,
                disabled: false,
                helperText: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.licenceNumber'
                ) as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.responsibles.newResponsibleFormFields.licenceNumber,
                validations: [{ name: 'required' }]
            },
            {
                type: 'text',
                label: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.grantingEntity'
                ) as string,
                name: 'grantingEntity',
                required: true,
                value: formData.grantingEntity,
                disabled: false,
                helperText: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.grantingEntity'
                ) as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.responsibles.newResponsibleFormFields.grantingEntity,
                validations: [{ name: 'required' }]
            },
            {
                type: 'text',
                label: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.hoursQuantity'
                ) as string,
                name: 'hoursQuantity',
                required: true,
                value: formData.hoursQuantity,
                disabled: false,
                inputType: 'number',
                helperText: t(
                    'responsiblesAndContractorsForms.newResponsible.inputs.hoursQuantity'
                ) as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                maxLength: 3,
                testID: TEST_IDS.responsibles.newResponsibleFormFields.hoursQuantity,
                validations: [
                    { name: 'required' },
                    { name: 'minValue', param: 1 },
                    { name: 'maxValue', param: 744 }
                ]
            }
        ];

        setResponsibleFieldsConfig(fieldsConfig);
    }, [t, formData.charge]);

    return {
        responsibleFieldsConfig
    };
};

export default useResponsibleFieldsConfig;
